export default {
  namespaced: true,

  state: {
    token: localStorage.getItem("token"),
    expiresDate: localStorage.getItem("expires_date"),
    isLoggedIn: !!localStorage.getItem("token"),
    hasError: false
  },
  mutations: {
    // ใช้ตอน login สำเร็จ
    loginUser(state, payload) {
      const token = typeof payload === "string" ? payload : payload.token;
      const expiresDate = payload.expires_date || null;

      localStorage.setItem("token", token);
      if (expiresDate) {
        localStorage.setItem("expires_date", expiresDate);
      }

      state.token = token;
      state.expiresDate = expiresDate;
      state.isLoggedIn = true;
    },

    logoutUser(state) {
      localStorage.removeItem("token");
      localStorage.removeItem("expires_date");

      state.token = null;
      state.expiresDate = null;
      state.isLoggedIn = false;
    },

    setAlert(state) {
      state.hasError = true;
    }
  },
  actions: {
    // ใช้ตอน logout จาก component หรือ guard
    logout({ commit }) {
      commit("logoutUser");
    },

    // optional: ใช้ตอน login error
    setAlert({ commit }) {
      commit("setAlert");
    }
  },
  getters: {
    // ใช้ใน router guard
    checkLogin: state => {
      if (!state.token) return false;

      // ถ้าไม่มี expire date ให้ถือว่า login ได้
      if (!state.expiresDate) return true;

      const now = new Date().getTime();
      const expire = new Date(state.expiresDate).getTime();

      return expire > now;
    },

    user: () => {
      return null;
    },

    hasError: state => state.hasError
  }
};
